import React, { useLayoutEffect, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { loadingStore } from '@pascal/pascal-core';
import { gameActiveVideoStore } from '../../../../../store/gameActiveVideoStore';
import { turnOffFullScreenMode } from '../../../../../helpers/turnOffFullScreenMode';
import FinishedScene from '../../../../../assets/video/end.mp4';
// import FinishedScene from '../../../../../assets/video/euro-2024/end.mp4';
import { videoTypes } from '../../../../../enums';

const GameFinishScene = observer(() => {
  const videoRef = useRef(null);

  const { gameLoading, timerFinished } = loadingStore;

  const stopMedia = (video) => {
    video.pause();
    video.currentTime = 0;
  };

  if (!gameActiveVideoStore.finish && videoRef.current) {
    stopMedia(videoRef.current);
  } else if (videoRef.current && gameActiveVideoStore.finish) {
    videoRef.current.play();
  }

  useLayoutEffect(() => {
    turnOffFullScreenMode(videoRef);
  }, []);

  const zIndex = gameActiveVideoStore.finish ? '2' : '0';

  return (
    <video
      className='video-absolute'
      muted
      playsInline
      ref={videoRef}
      src={FinishedScene}
      style={{ zIndex }}
      {...(gameLoading && !timerFinished ? { autoPlay: true } : {})}
      onLoadedData={() => gameActiveVideoStore.setLoadedVideos(videoTypes.finish, true)}
    />
  );
});
export default GameFinishScene;
